import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Admin, User, UserSuggestion } from 'src/app/shared/models/interfaces';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class GroupAdminsService {
  private groupAdminApiUrl = `${environment.api}/group-admins`;

  constructor(private http: HttpClient) {}

  getAdminsWithGroupDetails(): Observable<Admin[]> {
    return this.http.get<Admin[]>(`${this.groupAdminApiUrl}/details`);
  }

  promoteToSuperAdmin(userId: number): Observable<Admin> {
    return this.http.patch<Admin>(
      `${this.groupAdminApiUrl}/${userId}/promote-to-superadmin`,
      {}
    );
  }

  demoteToUser(userId: number): Observable<Admin> {
    return this.http.patch<Admin>(
      `${this.groupAdminApiUrl}/${userId}/demote-to-user`,
      {}
    );
  }

  searchUsersForAdminPromotion(
    searchTerm: string
  ): Observable<UserSuggestion[]> {
    if (!searchTerm) {
      return of([]);
    }

    return this.http.get<UserSuggestion[]>(
      `${this.groupAdminApiUrl}/suggestions-for-admin?q=${encodeURIComponent(
        searchTerm
      )}`
    );
  }

  promoteToGroupAdmin(userId: number): Observable<User> {
    return this.http.patch<User>(
      `${this.groupAdminApiUrl}/${userId}/promote-to-group-admin`,
      {}
    );
  }
}
